import { ShowComponent } from "../components";
import { connect } from "react-redux";
import { GetDataMenuAllAction } from "../../MenuRole/actions";
import { GetDataUserAction } from "../../MenuAuthorization/actions";
import { DeleteDataUserMenuAction, GetDataPermissionAction, GetDataUserMenuAction, SetDataUserMenuAction } from "../actions";

const mapStateToProps = state =>{
    return {
        ...state,
        DataMenu: state.allMenuRoleReducer.menuReducer.DataMenu,       
        DataUser: state.allMenuAuthorizationReducers.mainALLReducer.GetuserReducer.DataUser,
        DataPermission: state.allUserMenuReducer.menuRoleReducer.DataPermission,
        DataUserMenu: state.allUserMenuReducer.userMenuReducer.DataUserMenu,
        isResult: state.allUserMenuReducer.isResultReducer.isResult
    };
};

const mapDispatchToProps = dispatch =>{
    return {
        GetDataMenuAll: () => {
            dispatch(GetDataMenuAllAction());
        },
        GetDataUser: () => {
            dispatch(GetDataUserAction());
        },
        GetDataPermission: (DataMenu) => {
            dispatch(GetDataPermissionAction(DataMenu));
        },
        GetDataUserMenu: () =>{
            dispatch(GetDataUserMenuAction());
        },
        DeleteDataUserMenu: (ID) =>{
            dispatch(DeleteDataUserMenuAction(ID));
        },
        SetDataUserMenu: (DataUserMenu) =>{
            dispatch(SetDataUserMenuAction(DataUserMenu));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowComponent);